export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'shifts' as const;

export const RELATIONSHIP_TYPES = {
  ROLE: 'role',
  USER: 'user',
  SHIFT_EVENT: 'shift_event',
} as const;
